export enum DeploymentTargetTaskType {
    Deployment = "Deployment",
    RunbookRun = "RunbookRun",
}

export default DeploymentTargetTaskType;
